const BASE_AUTH_PATH = 'auth';
const BASE_SETTING_PATH = 'setting';

export const PATH_PAGE = {
  root: '/',
  cancel: '/cancel',
  auth: {
    signIn: `/${BASE_AUTH_PATH}/sign-in`,
    vscode: `/${BASE_AUTH_PATH}/vscode`,
  },
  onBoard: '/onboard',
  dashboard: {
    root: '/dashboard',
    orgById: (orgId: string) => `/dashboard/${orgId}`,
    workspaceById: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}`,
    newWorkspace: '/dashboard/new',
    llm: {
      root: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/llm-service`,
      credentials: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/llm-service/credentials`,
      activity: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/llm-service/activity`,
    },
    oneClickDeploy: {
      root: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/one-click-deploy`,
      create: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/one-click-deploy/create`,
      byId: {
        root: (orgId: string, wsId: string, deployId: string) =>
          `/dashboard/${orgId}/${wsId}/one-click-deploy/${deployId}`,
        deployments: (orgId: string, wsId: string, deployId: string) =>
          `/dashboard/${orgId}/${wsId}/one-click-deploy/${deployId}/deployments`,
        log: (orgId: string, wsId: string, deployId: string) =>
          `/dashboard/${orgId}/${wsId}/one-click-deploy/${deployId}/log`,
        usageAndCost: (orgId: string, wsId: string, deployId: string) =>
          `/dashboard/${orgId}/${wsId}/one-click-deploy/${deployId}/usage`,
        setting: (orgId: string, wsId: string, deployId: string) =>
          `/dashboard/${orgId}/${wsId}/one-click-deploy/${deployId}/setting`,
        activity: (orgId: string, wsId: string, deployId: string) =>
          `/dashboard/${orgId}/${wsId}/one-click-deploy/${deployId}/activity`,
      },
    },
    oneClickTraining: {
      root: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/one-click-training`,
    },
    serverlessGPU: {
      root: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/serverless-gpu`,
      byId: (orgId: string, wsId: string, projectId: string) => ({
        overview: `/dashboard/${orgId}/${wsId}/serverless-gpu/${projectId}/overview`,
        onboarding: `/dashboard/${orgId}/${wsId}/serverless-gpu/${projectId}/onboarding`,
        task: `/dashboard/${orgId}/${wsId}/serverless-gpu/${projectId}/tasks`,
        storageLogs: `/dashboard/${orgId}/${wsId}/serverless-gpu/${projectId}/storage-logs`,
        deploy: `/dashboard/${orgId}/${wsId}/serverless-gpu/${projectId}/deploy`,
        develop: `/dashboard/${orgId}/${wsId}/serverless-gpu/${projectId}/develop`,
        storage: `/dashboard/${orgId}/${wsId}/serverless-gpu/${projectId}/storage`,
        activity: `/dashboard/${orgId}/${wsId}/serverless-gpu/${projectId}/activity`,
        playground: `/dashboard/${orgId}/${wsId}/serverless-gpu/${projectId}/playground`,
        playgroundBlueprint: `/dashboard/${orgId}/${wsId}/serverless-gpu/${projectId}/playground-blueprint`,
        setting: `/dashboard/${orgId}/${wsId}/serverless-gpu/${projectId}/setting`,
      }),
      overview: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/serverless-gpu/overview`,
      onboarding: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/serverless-gpu/onboarding`,
      task: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/serverless-gpu/tasks`,
      storageLogs: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/serverless-gpu/storage-logs`,
      tokens: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/serverless-gpu/tokens`,
      pricing: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/serverless-gpu/pricing`,
      createProject: (orgId: string, wsId: string) =>
        `/dashboard/${orgId}/${wsId}/serverless-gpu/create-project`,
      blueprint: (orgId: string, wsId: string) => ({
        root: `/dashboard/${orgId}/${wsId}/serverless-gpu/blueprint`,
        byName: (path: string) =>
          `/dashboard/${orgId}/${wsId}/serverless-gpu/blueprint/item?name=${path}`,
      }),
    },
    ai: {
      root: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/ai`,
      overview: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/ai/overview`,
      credentials: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/ai/credentials`,
      module: (orgId: string, wsId: string, moduleId: string) => ({
        root: `/dashboard/${orgId}/${wsId}/ai/${moduleId}`,
        overview: `/dashboard/${orgId}/${wsId}/ai/${moduleId}/overview`,
        playground: `/dashboard/${orgId}/${wsId}/ai/${moduleId}/playground`,
        activity: `/dashboard/${orgId}/${wsId}/ai/${moduleId}/activity`,
        pricing: `/dashboard/${orgId}/${wsId}/ai/${moduleId}/pricing`,
      }),
    },
    gpuInstance: {
      root: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/gpu-instance`,
      overview: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/gpu-instance/overview`,
      instances: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/gpu-instance/instances`,
      create: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/gpu-instance/create`,
      volume: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/gpu-instance/volume`,
      pricing: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/gpu-instance/pricing`,
      volumeById: (orgId: string, wsId: string, volumeId: string) => ({
        root: `/dashboard/${orgId}/${wsId}/gpu-instance/volume/${volumeId}`,
        overview: `/dashboard/${orgId}/${wsId}/gpu-instance/volume/${volumeId}/overview`,
        snapshots: `/dashboard/${orgId}/${wsId}/gpu-instance/volume/${volumeId}/snapshots`,
      }),
      byId: (orgId: string, wsId: string, instanceId: string) => ({
        root: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}`,
        overview: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/overview`,
        logs: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/logs`,
        endpoint: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/endpoint`,
        tasks: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/tasks`,
        settings: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/settings`,
        // vLLM Routes
        playground: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/playground`,
        modelRepository: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/model-repository`,
        modelManagement: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/model-management`,
        modelTesting: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/model-testing`,
        botPrevention: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/bot-prevention`,
        // TAO 6.x Training Routes
        taoTraining: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/tao-training`,
        taoExperiments: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/tao-experiments`,
        taoDatasets: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/tao-datasets`,
        taoModels: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/tao-models`,
        // MONAI 1.5.1 Training Routes
        monaiExperiments: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/monai-experiments`,
        monaiDatasets: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/monai-datasets`,
        monaiModels: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/monai-models`,
        // NeMo 2.6.1 Training Routes
        nemoExperiments: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/nemo-experiments`,
        nemoDatasets: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/nemo-datasets`,
        nemoModels: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/nemo-models`,
        // OCR Routes
        ocrPlayground: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/ocr-playground`,
        ocrApiEndpoint: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/ocr-api-endpoint`,
        ocrMetrics: `/dashboard/${orgId}/${wsId}/gpu-instance/${instanceId}/ocr-metrics`,
      }),
    },
    setting: {
      general: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/setting/general`,
      organization: (orgId: string, wsId: string) => `/dashboard/${orgId}/${wsId}/setting/organization`,
    },
    // Organization settings (at org level, not workspace level)
    orgSetting: {
      general: (orgId: string) => `/dashboard/${orgId}/settings/general`,
      quota: (orgId: string) => `/dashboard/${orgId}/settings/quota`,
      members: (orgId: string) => `/dashboard/${orgId}/settings/members`,
      workspaces: (orgId: string) => `/dashboard/${orgId}/settings/workspaces`,
    },
  },

  setting: {
    workspaces: {
      root: `/${BASE_SETTING_PATH}/workspaces`,
    },
    profile: `/${BASE_SETTING_PATH}/profile`,
    tokens: `/${BASE_SETTING_PATH}/tokens`,
    payment: `/${BASE_SETTING_PATH}/payment`,
    serviceQuota: `/${BASE_SETTING_PATH}/service-quota`,
    coupon: `/${BASE_SETTING_PATH}/coupon`,
  },
};

export default PATH_PAGE;
